module.exports = __webpack_public_path__ + "media/images/sec_6-5-8e2a9c0d923fa4744193b3170cb8b6d2.png";